<template>
    <transition
        enter-from-class="scale-125 opacity-0"
        enter-to-class="scale-100 opacity-100"
        enter-active-class="transition-all transform ease-out duration-2000"
        mode="out-in"
        appear>
        <slot></slot>
    </transition>
</template>
